import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { setMobileMenuState } from '@Header/Navigation/ducks/actions';
import { openModal } from '@Header/Modals/ducks/actions';
import { useAnalytics } from '@Shared/useAnalytics';
import MenuButton from '../../Shared/MenuButton';
import MenuDrawerItem from '../../Shared/MenuDrawerItem';
import { ACCOUNT_MODAL } from '../../constants';
import { signInStatus } from '../../utilities/afterSignInSuccess';

const StyledMenuButton = styled(MenuButton)`
  color: ${props => props.theme.carvana.blue.primary};

  &:hover {
    color: ${props => props.theme.carvana.blue.dark};
  }

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    text-transform: uppercase;
  }
`;

const StyledMenuDrawerItem = styled(MenuDrawerItem)`
  background-color: ${props => props.theme.carvana.white.primary};
`;

const DesktopWrapper = styled.div`
  display: none;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: block;
  }
`;

const MobileWrapper = styled.div`
  display: block;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: none;
  }
`;

const SignInLink = ({
  openModal: openAccountModal,
  setMobileMenuStateAction
}) => {
  const { trackEvent } = useAnalytics();
  const signInClickHandler = (platform = '') => {
    signInStatus.setSignedIn(true);
    trackEvent('user platform - header - clicked sign in', { platform });
    openAccountModal(ACCOUNT_MODAL);
    setMobileMenuStateAction(false);
  };

  return (
    <>
      <DesktopWrapper>
        <StyledMenuButton
          dataCvTest="headerSignInLink"
          onClick={() => signInClickHandler('desktop')}
        >
          Sign In
        </StyledMenuButton>
      </DesktopWrapper>

      <MobileWrapper>
        <StyledMenuDrawerItem>
          <StyledMenuButton
            dataCvTest="headerMobileSignInLink"
            onClick={() => signInClickHandler('mobile')}
          >
            Sign In
          </StyledMenuButton>
        </StyledMenuDrawerItem>
      </MobileWrapper>
    </>
  );
};

SignInLink.propTypes = {
  openModal: PropTypes.func.isRequired,
  setMobileMenuStateAction: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  useModalUrlForAccountLinks: state.header.header.useModalUrlForAccountLinks
});

export default connect(mapStateToProps, { openModal, setMobileMenuStateAction: setMobileMenuState })(SignInLink);
